// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + chunkId + "." + {"31": "83e035cf","319": "2619777e","366": "9154912f","985": "482cb750",}[chunkId] + ".css"
}